const mediaItems = [
  {
    title: '《夏日幻境》第7话',
    tag: '新番更新',
    views: '12.8万',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20summer%20themed%20anime%20illustration%20with%20beautiful%20female%20character%20in%20flowing%20dress%20cherry%20blossom%20petals%20warm%20sunlight%20soft%20dreamy%20atmosphere%20pastel%20color%20palette%20cinematic%20composition&width=800&height=600&seq=media-summer-dream&orientation=landscape',
    alt: '夏日幻境第7话新番更新',
  },
  {
    title: '《剑与魔法》第12话',
    tag: '热血战斗',
    views: '18.3万',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20illustration%20with%20knight%20character%20holding%20sword%20magical%20effects%20dramatic%20lighting%20warm%20golden%20and%20orange%20tones%20dynamic%20pose%20cinematic%20composition&width=800&height=600&seq=media-sword-magic&orientation=landscape',
    alt: '剑与魔法第12话热血战斗',
  },
  {
    title: '《星之彼方》第3话',
    tag: '恋爱甜宠',
    views: '9.6万',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20with%20two%20characters%20under%20starry%20night%20sky%20cherry%20blossom%20petals%20soft%20pink%20and%20purple%20tones%20dreamy%20atmosphere%20cinematic%20lighting&width=800&height=600&seq=media-star-beyond&orientation=landscape',
    alt: '星之彼方第3话恋爱甜宠',
  },
  {
    title: '《异界食堂》第9话',
    tag: '搞笑日常',
    views: '7.2万',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20warm%20anime%20illustration%20of%20cafe%20interior%20with%20colorful%20characters%20enjoying%20food%20soft%20warm%20lighting%20cheerful%20atmosphere%20pastel%20color%20palette%20slice%20of%20life%20style&width=800&height=600&seq=media-isekai-cafe&orientation=landscape',
    alt: '异界食堂第9话搞笑日常',
  },
  {
    title: '《暗影追踪》第5话',
    tag: '悬疑推理',
    views: '11.4万',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20illustration%20with%20detective%20character%20in%20dark%20alley%20dramatic%20lighting%20warm%20amber%20street%20lights%20noir%20atmosphere%20suspenseful%20composition%20cinematic%20style&width=800&height=600&seq=media-shadow-hunt&orientation=landscape',
    alt: '暗影追踪第5话悬疑推理',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            追更视频
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            最新更新的热门番剧，精彩内容不容错过
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors duration-300">
                    <i className="ri-play-fill text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 text-xs text-background-50/90 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 font-heading truncate">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}